import axiosInstance from './axiosConfig';

const supplierAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/supplier', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch suppliers';
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/supplier/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch supplier';
    }
  },

  create: async (supplierData) => {
    try {
      const response = await axiosInstance.post('/supplier', supplierData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create supplier';
    }
  },

  update: async (id, supplierData) => {
    try {
      const response = await axiosInstance.put(`/supplier/${id}`, supplierData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update supplier';
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/supplier/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete supplier';
    }
  },

  // Additional supplier-specific methods
  getQuickList: async () => {
    try {
      const response = await axiosInstance.get('/supplier/quick-list');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch supplier quick list';
    }
  },
};

export default supplierAPI;